import {
    FETCH_JURISDICTIONS,
    FETCH_JURISDICTIONS_FAIL,
    FETCH_JURISDICTIONS_SUCCESS,
    SET_JURISDICTION
} from './actionTypes';

const initialState = {
    data: [],
    selectedJurisdiction: null,
    selectedBrand: null,
    loaded: false,
    loading: false,
    error: null
};

export function jurisdictionReducer(state = initialState, action) {
    switch (action.type) {
        case SET_JURISDICTION: {
            return {
                ...state,
                selectedJurisdiction: action.payload.jurisdiction,
                selectedBrand: action.payload.brand
            };
        }
        case FETCH_JURISDICTIONS: {
            const keepSelection = !!(
                action.payload && action.payload.keepSelection
            );

            return keepSelection
                ? { ...state, loading: true }
                : {
                      ...initialState,
                      loading: true
                  };
        }
        case FETCH_JURISDICTIONS_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                loaded: true,
                loading: false
            };
        }
        case FETCH_JURISDICTIONS_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        default:
            return state;
    }
}
